import { LuAlertCircle } from "react-icons/lu";

import { AdvisorButton } from "./AdvisorButton";
import { cn } from "./cn";

/** A plain inline error banner shown in the transcript when a step fails. */
export function ErrorBanner({
  message,
  onRetry,
  retryLabel = "Try again",
  className,
}: {
  message: string;
  /** Offered when the failure left the user with nothing else to act on. */
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2.5 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600",
        className
      )}
    >
      <LuAlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="flex min-w-0 flex-col items-start gap-2.5">
        <span>{message}</span>
        {onRetry && (
          <AdvisorButton size="sm" onClick={onRetry}>
            {retryLabel}
          </AdvisorButton>
        )}
      </div>
    </div>
  );
}
